export { default as SearchInput } from "./SearchInput";
export { default as Navbar } from "./Navbar";
export { default as CompaniesNav } from "./CompaniesNav";
export { default as Footer } from "./Footer";
export { default as ConfirmAlert } from "./ConfirmAlert";
export { default as CottonLabel } from "./CottonLabel";
export { default as CottonLogo } from "./CottonLogo";
export { default as TopLoader } from "./TopLoader";
export { default as ViewImage } from "./ViewImage";
export { default as Questions } from "./questions";
export { default as BlogSection } from "./blog-section";
export { default as ThemeSwitch } from "./theme-switch";
export { default as FindTalent } from "./FindTalent";
export { default as ApplyForJob } from "./ApplyForJob";

// about
export { default as AboutBanner } from "./AboutUs/banner";
export { default as WhoAreWe } from "./AboutUs/whoAreWe";
export { default as WhatMakesUsDifferent } from "./AboutUs/whatMakesUsDifferent";
export { default as MeetOurTeam } from "./AboutUs/meetOurTeam";
export { default as ComingSoon } from "./ComingSoon";
export { default as ComingSoon2 } from "./ComingSoon2";

// home
export { default as RecruitingHero } from "./Home/RecruitingHero";
export { default as JobAlert } from "./Home/JobAlert";
export { default as JobCard } from "./Home/JobCard";
export { default as JobList } from "./Home/JobList";
export { default as TeamMembers } from "./Home/TeamMembers";
export { default as WorkForceRecruiting } from "./Home/WorkForceRecruiting";
export { default as WhatSetUsApart } from "./Home/WhatSetUsApart";
export { default as RecruitmentPartner } from "./Home/RecruitmentPartner";
export { default as RecruitingImageSlider } from "./Home/RecruitingImageSlider";
export { default as TalentHunters } from "./Home/TalentHunters";
export { default as HiringRight } from "./Home/HiringRight";
export { default as TrackRecord } from "./Home/TrackRecord";
export { default as YouBelongHere } from "./Home/YouBelongHere";
export { default as TestimonialsSection } from "./Home/TestimonialsSection";
export { default as RecruitingWhyChooseCotton } from "./Home/RecruitingWhyChooseCotton";

// blog
export { default as BlogCard } from "./Blog/BlogCard";
export { default as BlogCategory } from "./Blog/BlogCategory";
export { default as BlogSubscribe } from "./Blog/BlogSubscribe";
export { default as LatestBlog } from "./Blog/LatestBlog";
export { default as Subscribe } from "./Blog/Subscribe";
export { default as CommentSection } from "./Blog/CommentSection";
export { default as SimilarBlog } from "./Blog/SimilarBlog";

// contact us
export { default as ContactCard } from "./ContactUs/ContactCard";
export { default as ContactForm } from "./ContactUs/ContactForm";

// icon
export { default as StarIcon } from "./icons/StarIcon";
